module.exports = __webpack_public_path__ + "static/media/maestro-about.e3742ced.png";